import { useState } from "react";
import { Modal } from "react-bootstrap";

import translate from "../../../services/Translate";
import DstButton from "../../DstButton/DstButton";
import Popup from "../../Popup/Popup";
import { ManageModuleExercicePopupProps } from "./ManageModuleExercicePopup.d";
import { deleteExercises } from "./ManageModuleExercicePopup.function";

const ManageModuleExercicePopup = ({ language, show, module, closeModal, userId }: ManageModuleExercicePopupProps) => {
  const [selectedExercises, setSelectedExercises] = useState<Array<number>>([]);
  const [loading, setLoading] = useState(false);

  const _toggleExercice = (exerciseId: number) => {
    setSelectedExercises((prev) =>
      prev.includes(exerciseId) ? prev.filter((id) => id !== exerciseId) : [...prev, exerciseId]
    );
  };

  const _toggleSelectAll = () => {
    const allExerciseIds = module.module.exercises.map((exercise: any) => exercise.exercise);
    const allSelected = allExerciseIds.every((id: number) => selectedExercises.includes(id));

    if (allSelected) {
      setSelectedExercises([]);
    } else {
      setSelectedExercises(allExerciseIds);
    }
  };

  const _resetSelection = () => {
    setSelectedExercises([]);
    closeModal();
  };

  return (
    <Popup
      modalTitle={translate(language, "PAGES.USER.OVERVIEW.MODULE.POPUP_PROGRESSION.TITLE")}
      show={show}
      onClose={_resetSelection}
    >
      <p className="mb-2">{translate(language, "PAGES.USER.OVERVIEW.MODULE.POPUP_PROGRESSION.DESCRIPTION")}</p>
      <p>{translate(language, "PAGES.USER.OVERVIEW.MODULE.POPUP_PROGRESSION.REMINDER")}</p>
      <p>{translate(language, "PAGES.USER.OVERVIEW.MODULE.POPUP_PROGRESSION.SELECT_EXERCICES")}</p>
      <DstButton
        value={translate(language, "PAGES.USER.OVERVIEW.MODULE.POPUP_PROGRESSION.SELECT_ALL")}
        variant="light"
        clickFunction={_toggleSelectAll}
      />
      <div className="d-flex flex-column">
        <div className="flex-grow-1">
          <div className="mb-3">
            {module.module.exercises.map((exercise: any, index: number) => (
              <div key={`exercise-${index}`} className="list-group-item list-group-item-action d-flex py-1 px-3">
                <div className="form-check me-3">
                  <input
                    type="checkbox"
                    className="me-2"
                    id={`exercise-${index}`}
                    checked={selectedExercises.includes(exercise.exercise)}
                    onChange={() => _toggleExercice(exercise.exercise)}
                  />
                </div>
                <label htmlFor={`exercise-${index}`} className="clickable flex-grow-1 mb-0">
                  {exercise.name}
                </label>
              </div>
            ))}
          </div>
        </div>

        <Modal.Footer>
          <DstButton variant="secondary" value={translate(language, "GLOBAL.CANCEL")} clickFunction={_resetSelection} />
          <DstButton
            variant="primary"
            value={translate(language, "GLOBAL.CONFIRM")}
            clickFunction={() => deleteExercises(userId, selectedExercises, language, setLoading, _resetSelection)}
            loading={loading}
            disabled={!selectedExercises.length}
          />
        </Modal.Footer>
      </div>
    </Popup>
  );
};

export default ManageModuleExercicePopup;
